export function userHasEnabledGlobalPrivacyControl(): boolean {
  return (
    typeof navigator !== 'undefined' &&
    'globalPrivacyControl' in navigator &&
    (navigator.globalPrivacyControl as boolean)
  )
}
